import {
  AlignmentDocumentControlNo,
  AmountInfoSettingType,
  ContactEnvelopePageSizeType,
  CurrencyCode,
  DateOptionType,
  DocumentFontType,
  DocumentFormat,
  DocumentHeaderSize,
  HeaderOptionName,
  HeaderOptionType,
  JournalHeaderOptionName,
  LanguageType,
  PaymentElementType,
  PositionSummarizeDefault,
  SettingAreaPunchingType,
  SettingCertifiedDate,
  SettingWhtItem40XShowingType,
  WithholdingTaxPageSizeType,
  WitholdingTaxDocumentDisplayType,
} from "@/enums/enums";
import { MerchantAddressModel } from "../address/addressModel";
import { ContactPersonEnvelopeModel } from "./contactEnvelopeModel";
import {
  ElementDataMerchantContactInfoModel,
  ElementDefaultModel,
  SettingPaymentGroupList,
  SettingPaymentMethodChannel,
} from "./documentModel";

export class SettingDefaultModel {
  value!: string;
  isShowElement!: boolean;

  constructor() {
    this.value = "";
    this.isShowElement = true;
  }
}

export class SettingDocumentControlNoModel {
  value!: string;
  alignment!: AlignmentDocumentControlNo;

  constructor() {
    this.value = "";
    this.alignment = AlignmentDocumentControlNo.None;
  }
}

export class SettingHeadTypeModel {
  isShowDocumentSet!: boolean;
  isShowHeaderOptionType!: boolean;
  headerTitleType!: HeaderOptionType;
  originalAmount!: number;
  copyAmount!: number;
}

export class SettingDocumentNameModel extends SettingDefaultModel {
  headerOptionType!: HeaderOptionName;
  documentHeaderSize!: DocumentHeaderSize;
  isShowTaxInvoice!: boolean;
  isShowNonTaxInvoice!: boolean;
}

export class SettingJournalTypeNameModel {
  purchaseJournal!: SettingJournalNameModel;
  salesJournal!: SettingJournalNameModel;
  paymentJournal!: SettingJournalNameModel;
  receiveJournal!: SettingJournalNameModel;
  generalJournal!: SettingJournalNameModel;
}

export class SettingJournalNameModel extends SettingDefaultModel {
  headerOptionName!: JournalHeaderOptionName;
}

export class SettingDataContactInfoModel {
  phoneNumber!: SettingDefaultModel;
  website?: SettingDefaultModel;
  email!: SettingDefaultModel;
}

export class SettingMerchantModel extends SettingDataContactInfoModel {
  isCustomTextDisplay!: boolean;
  isShowTextHeadOffice!: boolean;
  merchantTitle!: SettingDefaultModel;
  merchantAddressTemplate!: MerchantAddressModel;
}

export class SettingContactModel extends SettingDataContactInfoModel {
  isShowContact!: boolean;
  isCustomTextDisplay!: boolean;
  isShowTextHeadOffice!: boolean;
  isShowContactCode!: boolean;
  contactTitle!: SettingDefaultModel;
  dearTitle!: SettingDefaultModel;
}

export class SettingDocumentInfoModel {
  dateOptionType!: DateOptionType;
  documentNoTitle!: SettingDefaultModel;
  issedDateTitle!: SettingDefaultModel;
  creditTitle!: SettingDefaultModel;
  acceptedDateTitle!: SettingDefaultModel;
  dueDateTitle!: SettingDefaultModel;
  refTitle!: SettingDefaultModel;
  taxInvoiceNumberTitle!: SettingDefaultModel;
  taxInvoiceDateTimeTitle!: SettingDefaultModel;
  isCustomTextDisplay!: boolean;
  isShowIssueDateValue!: boolean;
}

export class SettingMerchantPersonModel extends SettingDataContactInfoModel {
  isShowMerchantPerson!: boolean;
  merchantPersonTitle!: SettingDefaultModel;
  merchantTitle!: SettingDefaultModel;
  isCustomTextDisplay!: boolean;
}

export class SettigColumnModel {
  isShowAmount!: boolean;
  isShowUnit!: boolean;
  isShowPrice!: boolean;
  isShowDiscount!: boolean;
  isShowVatAmount!: boolean;
  isShowPreVatAmount!: boolean;
  isShowIncVatAmount!: boolean;
  isShowWhtAmount!: boolean;
  isShowDocumentNumber!: boolean;
  isShowIssedDate!: boolean;
  isShowDueDate!: boolean;
  isShowBilledAmount!: boolean;
}

export class SettigDescriptionModel {
  isShowImage!: boolean;
  isShowName!: boolean;
  isShowCode!: boolean;
  isShowDescription!: boolean;
}

export class SettingAmountInfoModel {
  amountInfoSettingType!: AmountInfoSettingType;
  isCustomTextDisplay!: boolean;
  discountTitle!: SettingDefaultModel;
  nonVATAmountTitle!: SettingDefaultModel;
  zeroVATAmountTitle!: SettingDefaultModel;
  preVATAmountTitle!: SettingDefaultModel;
  vatAmountTitle!: SettingDefaultModel;
  netAmountTitle!: SettingDefaultModel;
  totalDocumentAmountAfterTitle!: SettingDefaultModel;
  referenceTransactionAmountTitle!: SettingDefaultModel;
}

export class SettingSummarizeInfoModel {
  isShowSummary!: boolean;
  isCustomTextDisplay!: boolean;
  positionSummarizeDefault!: PositionSummarizeDefault;
  summaryAmountTitle!: SettingDefaultModel;
  whtAmountTitle!: SettingDefaultModel;
  paymentAmountTitle!: SettingDefaultModel;
}

export class SettingWithholdingModel {
  isCustomTextDisplay!: boolean;
  whtAmountTitle!: SettingDefaultModel;
  paymentAmountTitle!: SettingDefaultModel;
}

export class SettingCertifiedModel {
  userCreateTitle!: SettingDefaultModel;
  userApproveTitle!: SettingDefaultModel;
  merchantStampTitle!: SettingDefaultModel;
  receivedByTitle!: SettingDefaultModel;
  stampTitle!: SettingDefaultModel;
  isShowUserCreateUrl!: boolean;
  isShowUserApproveUrl!: boolean;
  isShowUserCreateDate!: boolean;
  isShowUserApproveDate!: boolean;
  isShowUserApproveName!: boolean;
  isShowUserCreateName!: boolean;
  isShowMerchantStampUrl!: boolean;
  isCustomTextDisplay!: boolean;
  isShowQRCode!: boolean;
  settingCreateDate!: SettingCertifiedDate;
  settingApproveDate!: SettingCertifiedDate;
}

export class SettingJournalCertifiedModel {
  userCreateTitle!: SettingDefaultModel;
  userApproveTitle!: SettingDefaultModel;
  userReviewedTitle!: SettingDefaultModel;
  isShowUserCreateUrl!: boolean;
  isShowUserApproveUrl!: boolean;
  isShowUserReviewedUrl!: boolean;
  isShowUserCreateDate!: boolean;
  isShowUserApproveDate!: boolean;
  isShowUserApproveName!: boolean;
  isShowUserCreateName!: boolean;
  isShowUserReviewedDate!: boolean;
  isCustomTextDisplay!: boolean;
  isShowQRCode!: boolean;
}

export class SettingMerchantPaymentModel {
  paymentElementType!: PaymentElementType;
  settingPaymentGroupList!: SettingPaymentGroupList;
  settingPaymentMethodChannel!: SettingPaymentMethodChannel;
}

export class ExpenseClaimDetailModel {
  idCard!: SettingDefaultModel;
  expenseClaimNote!: SettingDefaultModel;
}

export class SettingDocumentTemplateModel {
  colorCode!: string;
  documentFontType!: DocumentFontType;
  documentFormat!: DocumentFormat;
  colorCodeCopy!: string;
  language!: LanguageType;
  areaPunchingType!: SettingAreaPunchingType;
  merchantLogo!: SettingDefaultModel;
  isShowEtaxInvoice!: boolean;
  isShowWatermarkPaid!: boolean;
  headType!: SettingHeadTypeModel;
  documentName!: SettingDocumentNameModel;
  merchant!: SettingMerchantModel;
  contact!: SettingContactModel;
  documentInfo!: SettingDocumentInfoModel;
  merchantPerson!: SettingMerchantPersonModel;
  settingColumn!: SettigColumnModel;
  settingDescription!: SettigDescriptionModel;
  amountInfo!: SettingAmountInfoModel;
  summarizeInfo!: SettingSummarizeInfoModel;
  merchantPayment!: SettingMerchantPaymentModel;
  remark!: SettingDefaultModel;
  reason!: SettingDefaultModel;
  expenseClaimDetail!: ExpenseClaimDetailModel;
  certified!: SettingCertifiedModel;
  settingCurrency!: CurrencyCode;
  dateOptionType!: DateOptionType;
  documentControlNo!: SettingDocumentControlNoModel;
}

export class SettingEnvelopeMerchantModel extends ElementDataMerchantContactInfoModel {
  merchantAddressTemplate!: MerchantAddressModel;
}

export class SettingEnvelopeContactModel {
  personTemplate!: ContactPersonEnvelopeModel;
  isShowContactName!: boolean;
  isShowContactPosition!: boolean;
  isShowContactTel!: boolean;
}

export class SettingContactEnvelopeDocumentTemplateModel {
  pageSize!: ContactEnvelopePageSizeType;
  merchant!: SettingEnvelopeMerchantModel;
  merchantLogo!: SettingDefaultModel;
  contact!: SettingEnvelopeContactModel;
}

export class SettingJournalDocumentTemplateModel {
  colorCode!: string;
  colorCodeCopy!: string;
  language!: LanguageType;
  areaPunchingType!: SettingAreaPunchingType;
  merchantLogo!: SettingDefaultModel;
  headType!: SettingHeadTypeModel;
  documentNameType!: SettingJournalTypeNameModel;
  merchant!: SettingMerchantModel;
  contact!: SettingContactModel;
  documentInfo!: SettingJournalInfoModel;
  certified!: SettingJournalCertifiedModel;
}

export class SettingJournalInfoModel {
  dateOptionType!: DateOptionType;
  documentNoTitle!: SettingDefaultModel;
  issedDateTitle!: SettingDefaultModel;
  jonalTypeTitle!: SettingDefaultModel;
  refTitle!: SettingDefaultModel;
  journalRefTaxNumberTitle!: SettingDefaultModel;
  journalRefTaxDateTitle!: SettingDefaultModel;
  isCustomTextDisplay!: boolean;
}

export class SettingWitholdingTaxCertifiedModel {
  isShowUserCreateUrl!: boolean;
  isShowUserApproveUrl!: boolean;
  isShowUserCreateDate!: boolean;
  isShowUserApproveDate!: boolean;
  isShowUserApproveName!: boolean;
  isShowUserCreateName!: boolean;
  isShowMerchantStampUrl!: boolean;
}

export class SettingPP30CertifiedModel {
  isShowUserCreateUrl!: boolean;
  isShowUserApproveUrl!: boolean;
  isShowUserCreateDate!: boolean;
  isShowUserApproveDate!: boolean;
  isShowUserCreateName!: boolean;
  isShowUserApproveName!: boolean;
  isShowMerchantStampUrl!: boolean;
}

export class SettingPndCertifiedModel {
  isShowUserCreateUrl!: boolean;
  isShowUserApproveUrl!: boolean;
  isShowUserCreateDate!: boolean;
  isShowUserApproveDate!: boolean;
  isShowUserCreateName!: boolean;
  isShowUserApproveName!: boolean;
  isShowMerchantStampUrl!: boolean;
}

export class SettingDocumentNumberWitholdingTaxModel {
  isShowRefOne!: boolean;
  isShowRefTwo!: boolean;
  isShowWhtNumber!: boolean;
}

export class SettingWitholdingTaxDocumentTemplateModel {
  pageSize!: WithholdingTaxPageSizeType;
  documentNumber!: SettingDocumentNumberWitholdingTaxModel;
  displayType!: WitholdingTaxDocumentDisplayType;
  showDisplayType!: boolean;
  certified!: SettingWitholdingTaxCertifiedModel;
  whtItem40XShowingType!: SettingWhtItem40XShowingType;
}

export class SettingPP30DocumentTemplateModel {
  certified!: SettingPP30CertifiedModel;
  colorCode!: string;
  language!: LanguageType;
  merchantLogo!: SettingDefaultModel;
  headType!: SettingHeadTypeModel;
  merchant!: SettingMerchantModel;
  documentInfo!: SettingPP30TransactionInfoModel;
  pp30TransactionCertified!: SettingPP30TransactionCertifiedModel;
  settingVatFormType!: number;
  documentName!: ElementDefaultModel;
}

export class SettingPndDocumentTemplateModel {
  certified!: SettingPndCertifiedModel;
}

export class SettingPP30TransactionInfoModel {
  dateOptionType!: DateOptionType;
  formNumberTitle!: SettingDefaultModel;
  issueDateTitle!: SettingDefaultModel;
  formDateTitle!: SettingDefaultModel;
  isCustomTextDisplay!: boolean;
}
export class SettingPP30TransactionCertifiedModel {
  userCreateTitle!: SettingDefaultModel;
  userApproveTitle!: SettingDefaultModel;
  isShowUserCreateUrl!: boolean;
  isShowUserApproveUrl!: boolean;
  isShowUserCreateDate!: boolean;
  isShowUserApproveDate!: boolean;
  isShowUserCreateName!: boolean;
  isShowUserApproveName!: boolean;
  isCustomTextDisplay!: boolean;
  isShowQRCode!: boolean;
}
export class SettingExecutiveSummaryDocumentTemplateModel {
  merchantLogo!: SettingDefaultModel;
  documentName!: SettingExecutiveSummaryDocuemntNameModel;
  header!: SettingExecutiveSummaryHeaderModel;
}

export class SettingExecutiveSummaryDocuemntNameModel extends SettingDefaultModel {
  headerOptionType!: HeaderOptionName;
}

export class SettingExecutiveSummaryHeaderModel {
  originalAmount!: number;
  isShowPeriodDate!: boolean;
  isShowCreateUser!: boolean;
  isShowCreateDate!: boolean;
}
